<template>
  <div class="taxInvoice">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="getPlaceHolder()"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-tabs
      v-model="menuState"
      @change="stateChanged"
      title-active-color="#009ed4"
      color="#009ed4"
      swipeable
    >
      <van-tab
        v-for="(menu, index) in menuList"
        :key="index"
        :title="menu.title + (menu.count > 0 ? ' ' + menu.count : '')"
        :name="menu.name"
      >
        <van-list
          class="list"
          v-model="loading"
          :finished="finished"
          :finished-text="$t.meta.noMore"
          :error.sync="error"
          :error-text="errorText"
          @load="getList(page + 1)"
        >
          <div class="list-container" v-for="(item, index) in tableData" :key="index">
            <div class="checkBox">
              <van-checkbox
                v-model="item.isSelected"
                @change="handleCheckBox"
              ></van-checkbox>
            </div>
            <div class="container" @click="gotoDetail(item)">
              <template v-if="menuState == 1">
                <div class="list-item">
                  {{ $t.taxInvoice.mainWbNumber }}：{{ item.PWB_Number }}
                </div>
                <div class="list-item">
                  {{ $t.taxInvoice.sideWbNumber }}：{{ item.WB_Number }}
                </div>
                <div class="list-item">
                  {{ $t.taxInvoice.invoiceNo }}：{{ item.InvoiceNo }}
                </div>
                <div class="list-item">
                  {{ $t.taxInvoice.billDate }}：{{ item.InvoiceDate }}
                </div>
                <div class="list-item">
                  {{ $t.taxInvoice.payerName1 }}：{{ item.CompanyNameSn }}
                </div>
                <div class="list-item">
                  {{ $t.taxInvoice.invoiceAmount }} ({{ settlementCurrency }})：{{
                    item.PayableTotalAmount
                  }}
                </div>
                <div class="list-item">
                  {{ $t.taxInvoice.invoiceType2 }}：<van-icon
                    name="success"
                    v-if="item.IsPartialInvoice"
                    color="#13ce66"
                    size="14"
                  />
                </div>
              </template>
              <template v-if="menuState == 2">
                <div class="list-item">
                  {{ $t.taxInvoice.invoiceNumber }}：{{ item.InvoiceNumber }}
                </div>
                <div class="list-item">
                  {{ $t.taxInvoice.invoiceDate }}：{{ item.CreateTime }}
                </div>
                <div class="list-item">
                  {{ $t.taxInvoice.invoiceType }}：
                  <span v-if="item.InvoiceType == 1">{{
                    $t.taxInvoice.invoiceType1
                  }}</span>
                  <span v-if="item.InvoiceType == 2">{{
                    $t.taxInvoice.invoiceType2
                  }}</span>
                </div>
                <div class="list-item">
                  {{ $t.taxInvoice.payerName1 }}：{{ item.CompanyNameSn }}
                </div>
              </template>
              <template v-if="menuState == 3">
                <div class="list-item">
                  {{ $t.taxInvoice.invoiceNumber }}：{{ item.InvoiceNumber }}
                </div>
                <div class="list-item">
                  {{ $t.taxInvoice.issuedDate }}：{{ item.IssuedDate }}
                </div>
                <div class="list-item">
                  {{ $t.taxInvoice.invoiceType }}：
                  <span v-if="item.InvoiceType == 1">{{
                    $t.taxInvoice.invoiceType1
                  }}</span>
                  <span v-if="item.InvoiceType == 2">{{
                    $t.taxInvoice.invoiceType2
                  }}</span>
                </div>
                <div class="list-item">
                  {{ $t.taxInvoice.payerName1 }}：{{ item.CompanyNameSn }}
                </div>
              </template>
            </div>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.meta.searchType }}</div>
        <van-radio-group v-model="searchType" direction="horizontal">
          <van-radio
            :name="item.value"
            v-for="(item, index) in searchTypeOptions"
            :key="index"
            >{{ item.text }}</van-radio
          >
        </van-radio-group>

        <div class="radio-label">{{ $t.meta.customerTitle }}</div>
        <van-radio-group v-model="customerType" direction="horizontal">
          <van-radio :name="1">{{ $t.meta.enterprise }}</van-radio>
          <van-radio :name="2">{{ $t.meta.personal }}</van-radio>
        </van-radio-group>

        <template v-if="menuState == 1">
          <div class="radio-label">{{ $t.meta.statistics }}</div>
          <van-radio-group v-model="dataQueryCriteria" direction="horizontal">
            <van-radio :name="0">{{ $t.taxInvoice.all }}</van-radio>
            <van-radio :name="1">{{ $t.taxInvoice.dataOtion1 }}</van-radio>
            <van-radio :name="2">{{ $t.taxInvoice.dataOtion2 }}</van-radio>
          </van-radio-group>

          <div class="radio-label">{{ $t.meta.currency }}</div>
          <van-radio-group v-model="currency" direction="horizontal">
            <van-radio
              :name="currency.SCId"
              v-for="(currency, index) in currencyList"
              :key="index"
              >{{ currency.CurrencySn }}</van-radio
            >
          </van-radio-group>
        </template>

        <div class="custom-date">
          <div class="date-label">{{ $t.meta.date }}</div>
          <van-button class="date-btn1" type="info" size="small" @click="showStartDate">{{
            $t.meta.beginDate
          }}</van-button>
          <van-button class="date-btn2" type="info" size="small" @click="showEndDate">{{
            $t.meta.endDate
          }}</van-button>
          <div class="date-txt" v-if="beginTime || endTime">
            {{ beginTime }} {{ $t.meta.to }} {{ endTime }}
          </div>
        </div>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <van-popup v-model="showStartPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.beginDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'start')"
        @cancel="showStartPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showEndPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.endDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'end')"
        @cancel="showEndPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-dialog
      :title="dialogTitle"
      width="90%"
      v-model="showDialog"
      @confirm="dialogConfirm"
      @cancel="dialogCancel"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
      className="taxInvoice-dialog"
    >
      <slot name="default">
        <div class="taxInvoice-alert">
          <van-form label-width="80px">
            <van-field
              clickable
              readonly
              required
              :value="itemForm.itemName"
              :label="$t.taxInvoice.invoiceItem"
              :placeholder="$t.meta.select"
              @click="onShowEmit('showtaxInvoiceItem')"
            />

            <van-field
              v-model="itemForm.remark"
              :label="$t.taxInvoice.remark"
              type="textarea"
              required
            />

            <template v-if="itemForm.invoiceType == 2">
              <div
                class="dialog-container"
                v-for="(item, index) in checkedList"
                :key="index"
              >
                <div class="dialog-item">
                  {{ $t.taxInvoice.invoiceNo }}：{{ item.InvoiceNo }}
                </div>
                <div class="dialog-item">
                  {{ $t.taxInvoice.payerName1 }}：{{ item.CompanyNameSn }}
                </div>
                <div
                  class="dialog-table"
                  v-if="
                    item.selectedInvoice.PayableAmountList &&
                    item.selectedInvoice.PayableAmountList.length > 0
                  "
                >
                  <div class="dialog-table-label">
                    {{ $t.taxInvoice.invoiceTotal }}
                  </div>
                  <div
                    class="dialog-table-item"
                    v-for="(item, index) in item.selectedInvoice.PayableAmountList"
                    :key="index"
                  >
                    <div class="item1">{{ item.CurrencySn }}</div>
                    <div class="item2">{{ item.TotalAmount }}</div>
                  </div>

                  <div class="dialog-radio-label">{{ $t.meta.currency }}</div>
                  <van-radio-group
                    v-model="item.selectedInvoice.currency"
                    direction="horizontal"
                    class="dialog-radio-group"
                  >
                    <van-radio
                      :name="currency.SCId"
                      v-for="(currency, index) in currencyList"
                      :key="index"
                      >{{ currency.CurrencySn }}</van-radio
                    >
                  </van-radio-group>

                  <van-field
                    v-model="item.selectedInvoice.InvoiceAmount"
                    :label="$t.taxInvoice.invoiceAmountSn"
                    required
                  />
                </div>
              </div>
            </template>
          </van-form>
        </div>
      </slot>
    </van-dialog>

    <option-list
      event="showtaxInvoiceItem"
      :options="itemList"
      @onSelect="onSelectItem"
    ></option-list>

    <van-action-sheet v-model="sheetShow" :actions="sheetActions" @select="sheetSelect" />

    <div class="tool-bar">
      <van-button
        type="info"
        block
        @click="handleSheetShow"
        :disabled="checkedList.length > 0 ? false : true"
        >{{ $t.meta.menu }}</van-button
      >
    </div>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Icon,
  Form,
  Field,
  ActionSheet,
  Popup,
  DatetimePicker,
  Radio,
  RadioGroup,
  Checkbox,
  Tab,
  Tabs,
} from "vant";

import Vue from "vue";
import OptionList from "@components/optionList/OptionList.vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Icon)
  .use(Form)
  .use(Field)
  .use(ActionSheet)
  .use(Popup)
  .use(DatetimePicker)
  .use(Radio)
  .use(RadioGroup)
  .use(Checkbox)
  .use(Tab)
  .use(Tabs);

export default {
  name: "taxInvoice",
  components: {
    OptionList,
  },
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      settlementCurrency: "",
      menuState: this.$route.query.state
        ? this.$route.query.state
        : parseInt(localStorage.getItem("MenuState")),
      menuList: [
        {
          title: this.$t.taxInvoice.tab1,
          name: 1,
          count: 0,
        },
        {
          title: this.$t.taxInvoice.tab2,
          name: 2,
          count: 0,
        },
        {
          title: this.$t.taxInvoice.tab3,
          name: 3,
          count: 0,
        },
      ],
      page: 0,
      pageSize: 10,
      tableData: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      currencyList: [],
      itemList: [],
      dialogItemList: [],
      //filter
      searchText: "",
      searchType: 1,
      searchTypeOptions: [
        {
          text: this.$t.taxInvoice.invoiceNo,
          value: 1,
        },
        {
          text: this.$t.taxInvoice.wbNumber,
          value: 2,
        },
        {
          text: this.$t.taxInvoice.warehouseWorkNumber,
          value: 3,
        },
        {
          text: this.$t.taxInvoice.customerNumber,
          value: 4,
        },
        {
          text: this.$t.taxInvoice.companyName,
          value: 5,
        },
        {
          text: this.$t.taxInvoice.recommend,
          value: 6,
        },
      ],
      dataQueryCriteria: 1,
      currency: null,
      customerType: null,
      showFilter: false,
      //日期
      selectDate: new Date(),
      currentDate: "",
      showStartPicker: false,
      beginTime: "",
      showEndPicker: false,
      endTime: "",
      //操作菜单
      checkedList: [],
      sheetShow: false,
      sheetActions: [],
      showStatePicker: false,
      //弹窗
      showDialog: false,
      dialogTitle: this.$t.taxInvoice.applyInvoice,
      itemForm: {
        invoiceType: 1,
        itemId: "",
        itemName: "",
        remark: "",
      },
    };
  },
  watch: {
    menuState() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
      this.checkedList = [];
      this.getList(1);
    },
  },
  created() {
    this.defaultDate();
    this.getCurrencyList();
  },
  methods: {
    invoicedRefund() {
      this.$commonMethod.showLoading();
      var param = this.checkedList;
      this.$api.financialManagement
        .invoicedRefund(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.initList();
          this.getList(this.page);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    hadAppliedInvoicedRefund() {
      this.$commonMethod.showLoading();
      var param = this.checkedList;
      this.$api.financialManagement
        .hadAppliedInvoicedRefund(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.initList();
          this.getList(this.page);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    initData() {
      this.itemForm.invoiceType = 1;
      this.itemForm.itemId = "";
      this.itemForm.itemName = "";
      this.itemForm.remark = "";
      this.checkedList = [];
      for (var table of this.tableData) {
        table.isSelected = false;
      }
    },
    onSelectItem(item) {
      this.itemForm.itemName = item.text;
      this.itemForm.itemId = item.value;
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    dialogConfirm() {
      this.$commonMethod.showLoading();
      var ibList = [];
      for (var invoice of this.checkedList) {
        if (this.itemForm.invoiceType == 2) {
          ibList.push({
            CustomerId: invoice.CustomerId,
            InvoiceNo: invoice.InvoiceNo,
            SCId: invoice.selectedInvoice.currency,
            InvoiceAmount: invoice.selectedInvoice.InvoiceAmount,
          });
        } else {
          ibList.push({
            CustomerId: invoice.CustomerId,
            InvoiceNo: invoice.InvoiceNo,
          });
        }
      }
      let param = {
        InvoiceType: this.itemForm.invoiceType,
        ItemId: this.itemForm.itemId,
        Remark: this.itemForm.remark,
        IbList: ibList,
      };
      this.$api.financialManagement
        .addTaxInvoice(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.initList();
          this.initData();
          this.getList(this.page);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    dialogCancel() {
      this.showDialog = false;
      this.initData();
    },
    sheetSelect(e) {
      if (this.menuState == 1) {
        if (e.className == "1") {
          this.dialogTitle = this.$t.taxInvoice.applyInvoice;
          this.itemForm.invoiceType = 1;
        }
        if (e.className == "2") {
          this.itemForm.invoiceType = 2;
          this.dialogTitle = this.$t.taxInvoice.applyHalfInvoice;
        }
        this.getInvoiceItemList().then((success) => {
          if (success) this.showDialog = true;
        });
      }
      if (this.menuState == 2) {
        this.hadAppliedInvoicedRefund();
      }
      if (this.menuState == 3) {
        this.invoicedRefund();
      }
      this.sheetShow = false;
    },
    handleSheetShow() {
      var actions = [];
      if (this.menuState == 1) {
        actions = [
          { name: this.$t.taxInvoice.applyInvoice, className: "1" },
          { name: this.$t.taxInvoice.applyHalfInvoice, className: "2" },
        ];
      }
      if (this.menuState == 2) {
        actions = [{ name: this.$t.taxInvoice.refundApplyInvoice, className: "1" }];
      }
      if (this.menuState == 3) {
        actions = [{ name: this.$t.taxInvoice.refundInvoice, className: "1" }];
      }
      this.sheetActions = actions;
      this.sheetShow = true;
    },
    handleCheckBox() {
      var list = [];
      var items = this.tableData.filter((p) => p.isSelected);
      for (var item of items) {
        if (this.menuState == 1) {
          list.push({
            //只显示
            CompanyNameSn: item.CompanyNameSn,
            //提交参数
            selectedInvoice: {
              InvoiceNo: item.InvoiceNo,
              PayableAmountList: item.PayableAmountList,
              SCId: item.SCId,
              InvoiceAmount: item.InvoiceAmount,
            },
            CustomerId: item.CustomerId,
            InvoiceNo: item.InvoiceNo,
          });
        } else {
          list.push({
            InvId: item.InvId,
          });
        }
      }
      this.checkedList = list;
    },
    defaultDate() {
      let date = new Date();
      let year = date.getFullYear().toString();
      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1).toString()
          : (date.getMonth() + 1).toString();
      let da =
        date.getDate() < 10 ? "0" + date.getDate().toString() : date.getDate().toString();
      let end = year + "-" + month + "-" + da;
      let beg = year + "-" + month + "-01";
      this.beginTime = beg;
      this.endTime = end;
    },
    getCurrencyList() {
      return new Promise((resolve) => {
        this.$api.financialManagement
          .getSystemAvailableCurrencyList()
          .then((res) => {
            this.currencyList = res.data;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getInvoiceItemList() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        this.$api.financialManagement
          .getInvoiceItemListByCompanyId()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.ItemName,
                value: item.ItemId,
              };
              result.push(data);
            });
            this.itemList = result;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    gotoDetail(item) {
      var data = item;
      data.menuState = this.menuState;
      data.SettlementCurrency = this.settlementCurrency;
      localStorage.setItem("taxInvoiceDetail", JSON.stringify(data));
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "taxInvoiceDetail",
        name: "taxInvoiceDetail",
        query: [],
      });
    },
    getPlaceHolder() {
      var search = this.searchTypeOptions.find((c) => c.value == this.searchType);
      if (search) {
        return search.text;
      } else {
        return this.$t.meta.searchText;
      }
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    isFilter() {
      if (this.customerType || this.currency) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.searchType = 1;
      this.customerType = null;
      this.dataQueryCriteria = 1;
      this.currency = null;
      this.defaultDate();
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    showStartDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showStartPicker = true;
    },
    showEndDate() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = end;
      this.showEndPicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date, type) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == "start") {
        this.beginTime = formatDate(date);
        this.showStartPicker = false;
      }
      if (type == "end") {
        this.endTime = formatDate(date);
        this.showEndPicker = false;
      }
    },
    stateChanged(state) {
      this.menuState = state;
      localStorage.setItem("MenuState", JSON.stringify(state));
      this.searchText = "";
      this.searchType = 1;
    },
    getList(page) {
      return new Promise((resolve, reject) => {
        var param = {
          PageIndex: page,
          PageSize: this.pageSize,
          CustomerType: this.customerType,
          DataQueryCriteria: this.dataQueryCriteria,
          SCId: this.currency,
          InvoiceNo: this.searchType == 1 ? this.searchText : "",
          WB_Number: this.searchType == 2 ? this.searchText : "",
          WarehouseWorkNumber: this.searchType == 3 ? this.searchText : "",
          CustomerNumber: this.searchType == 4 ? this.searchText : "",
          CompanyName: this.searchType == 5 ? this.searchText : "",
          Referrer: this.searchType == 6 ? this.searchText : "",
          BeginTime: this.beginTime,
          EndTime: this.endTime,
        };
        var request = null;
        if (this.menuState == 2) {
          param.InvoiceState = 1;
          request = this.$api.financialManagement.getTaxInvoiceList(param);
        } else if (this.menuState == 3) {
          param.InvoiceState = 2;
          request = this.$api.financialManagement.getTaxInvoiceList(param);
        } else {
          request = this.$api.financialManagement.getAvailableInvoiceList(param);
        }
        request
          .then((res) => {
            if (this.menuState == 2 || this.menuState == 3) {
              this.tableData = this.tableData.concat(res.data.Data);
            } else {
              this.tableData = res.data.InvoiceList;
              this.settlementCurrency = res.data.SettlementCurrency;
            }
            this.loading = false;
            this.error = false;
            this.errorText = "";

            if (this.menuState == 1) {
              this.finished = true;
            } else {
              this.page = res.meta.page;
              this.finished = this.page >= res.meta.lastPage;
            }
            resolve(true);
          })
          .catch((error) => {
            this.loading = false;
            this.error = true;
            this.errorText = error.message;
            reject();
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.taxInvoice {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          margin-right: 10px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      .checkBox {
        vertical-align: middle;
        display: inline-block;
        margin: 15px;
      }
      .container {
        box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
        padding: 10px;
        .list-item {
          margin-bottom: 10px;
        }
        .list-item:last-child {
          margin-bottom: 0px;
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
  .taxInvoice-dialog {
    top: 50% !important;
    .taxInvoice-alert {
      overflow: scroll;
      height: 120vw;
      margin-top: 30px;
      .dialog-container {
        margin-top: 15px;
        padding: 15px;
        font-size: 12px;
        color: #333;
        box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.5);
        .dialog-item {
          margin-bottom: 10px;
        }
        .dialog-table {
          .dialog-table-label {
            margin-bottom: 10px;
          }
          .dialog-table-item {
            display: inline-block;
            width: 33.33%;
            text-align: center;
            margin-bottom: 10px;
            .item1 {
              padding: 10px;
              background: #1e90ff;
              color: #ffffff;
            }
            .item2 {
              padding: 10px;
              background: #e8f4ff;
            }
          }
          .dialog-radio-label {
            color: #333;
            margin-bottom: 10px;
            font-size: 12px;
          }
          .dialog-radio-group {
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}
</style>
